"use client";

import { ContactForm } from "@/components/ContactForm";
import { useLanguage } from "@/components/LanguageProvider";

type Props = { turnstileSiteKey: string; captchaSkip: boolean };

export function ContactContent({ turnstileSiteKey, captchaSkip }: Props) {
  const { t, dir } = useLanguage();

  return (
    <div className="mx-auto max-w-2xl px-4 py-14 md:py-20" dir={dir}>
      <header className="mb-10 text-center">
        <p className="text-xs font-bold uppercase tracking-widest text-[var(--accent)]">
          {t("contact.badge")}
        </p>
        <h1 className="mt-2 text-4xl font-extrabold text-[var(--primary)]">
          {t("contact.title")}
        </h1>
        <p className="mx-auto mt-4 max-w-lg text-slate-600">
          {t("contact.subtitle")}
        </p>
      </header>
      <ContactForm turnstileSiteKey={turnstileSiteKey} captchaSkip={captchaSkip} />
    </div>
  );
}
